var map = {
	"./ajax-94-95-home/ajax1.jpg": "c007",
	"./ajax-94-95-home/ajax2.jpg": "3dd8",
	"./borussia-17-18-home/borussia1.jpg": "5aaa",
	"./borussia-17-18-home/borussia2.jpg": "443d",
	"./borussia-17-18-home/borussia3.jpg": "88b8",
	"./celtic-18-19-home/celtic1.jpg": "c263",
	"./celtic-18-19-home/celtic2.jpg": "9a3c",
	"./celtic-18-19-home/celtic3.jpg": "5f35",
	"./france-08-home/france1.jpg": "8c81",
	"./france-08-home/france2.jpg": "a609",
	"./france-08-home/france3.jpg": "0a1d",
	"./france-08-home/france4.jpg": "680b",
	"./hjk-13-14-home/hjk1.jpg": "a3d9",
	"./hjk-13-14-home/hjk2.jpg": "ec71",
	"./manutd-94-95-away/manutd1.jpg": "1c40",
	"./manutd-94-95-away/manutd2.jpg": "3135",
	"./manutd-94-95-away/manutd3.jpg": "af4d",
	"./manutd-98-99-home/manutd1.jpg": "c390",
	"./manutd-98-99-home/manutd2.jpg": "7e24",
	"./manutd-98-99-home/manutd3.jpeg": "385f",
	"./milan-18-19-home/milan1.jpg": "730b",
	"./milan-18-19-home/milan2.jpg": "2438",
	"./milan-18-19-home/milan3.jpg": "0935",
	"./sampdoria-17-18-home/sampdoria1.jpg": "277d",
	"./spfc-12-away/spfc1.jpg": "cf45",
	"./spfc-12-away/spfc2.jpg": "087c",
	"./spfc-12-away/spfc3.jpg": "ef3a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9af2";